"use client";

import {
  PAID_AD_CHANNEL_CHANGED_EVENT,
  type PaidAdChannel,
  getStoredPaidAdChannel,
} from "@/lib/analytics/paid-ad";
import { useEffect, useState } from "react";

/**
 * Client-only hook returning the paid-ad channel the visitor arrived from
 * (currently only "meta"), or null. Returns null until the first client effect
 * runs, and reacts to the persisted channel being set during the landing render.
 */
export function usePaidAdChannel(): PaidAdChannel | null {
  const [channel, setChannel] = useState<PaidAdChannel | null>(null);

  useEffect(() => {
    const refresh = () => setChannel(getStoredPaidAdChannel());

    refresh();

    const onChanged = () => refresh();
    window.addEventListener(PAID_AD_CHANNEL_CHANGED_EVENT, onChanged);

    return () => {
      window.removeEventListener(PAID_AD_CHANNEL_CHANGED_EVENT, onChanged);
    };
  }, []);

  return channel;
}
